import React from 'react';
import { Modal, Typography } from 'antd';

const { Text } = Typography;

const ImpersonateModal = ({ visible, loading, onConfirm, onCancel }) => {
  return (
    <Modal
      title="Confirm Impersonation"
      visible={visible}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Yes, Impersonate"
      cancelText="Cancel"
    >
      <p>Are you sure you want to impersonate this user?</p>
      <p>You will be redirected to the user's dashboard in a new tab.</p>
      <Text type="warning">
        Warning: This action will give you access as this user. Use with caution.
      </Text>
    </Modal>
  );
};

export default ImpersonateModal;